<template>
    <div class="m-3">
        <AlertDismiss ref="alertDismiss"></AlertDismiss>

        <b-overlay :show="loading" class="overlay" :opacity="0.5">
            <div v-if="empty" class="card">
                <div class="card-body">
                    Aún no se han creado cursos, contacte con el administrador.
                </div>
            </div>

            <b-card-group deck class="card-container">
                <CourseCard class="element m-2 align-top" v-for="course in courses" :key="course.id" :course="course"/>
            </b-card-group>
        </b-overlay>
        <CoursePagination v-show="!loading" class="d-flex justify-content-end"/>
    </div>
</template>

<script>
import AlertDismiss from '../shared/Alert-dismiss.vue';
import CourseCard from './CoursesContent/Course-card.vue';
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'
import CoursePagination from './CoursesContent/Course-pagination.vue';

export default {
    name: 'CoursesContent',

    data() {
        return {
            courses: null,
            loading: false
        }
    },

    computed: {
        empty() {
            return this.courses && this.courses.length === 0;
        }
    },

    components: {
        CourseCard,
        AlertDismiss,
        CoursePagination,
    },


    async mounted() {
        this.$eventBus.$on(EventNames.PaginationFilterCourse, async (filter) => {
            await this.getCourses(filter);
        });
    },

    methods: {
        ...mapActions(["allCoursesForPage"]),

        async getCourses(query) {
            this.loading = true;
            let result = await this.allCoursesForPage(query);
            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.error.message);
                this.loading = false;
            }

            this.courses = result.data;
            this.loading = false;
        }
    }
}

</script>

<style scoped>
.element {
    display: inline-block;
    width: 240px;
}

.card-container {
  max-height: 55vh;
  min-height: 55vh;
  overflow-y: auto;
}

.overlay {
    min-height: 100px;
}
</style>
